import BoardListContext from '@/context/apps/board/BoardListContext';
import { useRouter } from '@/routing/useAppRouter';
import { useContext } from 'react';

import TabButton from '@/components/shared/ui/tab/TabButton';
import TabText from '@/components/shared/ui/tab/TabText';

type Props = {
  filterPath?: string;
};

export default function BoardListCategory({ filterPath }: Props) {
  const { bcatsData } = useContext(BoardListContext);

  const router = useRouter();
  const category = String(router.query.category || '');
  const subCategoryList = getSubCategoryList(bcatsData, category);

  return (
    <>
      <TabText
        hasInnerArea
        scroll={false}
        items={getCategoryItems(bcatsData, filterPath)}
      />
      <div className="mb-10 mt-5 flex justify-start lg:mb-[60px] lg:mt-8">
        <TabButton
          hasInnerArea
          items={getSubCategoryItems(
            subCategoryList,
            category,
            filterPath,
          )}
        />
      </div>
    </>
  );
}

const getCategoryItems = (list: any, filterPath?: string) => {
  return (
    list.map((item: any) => ({
      key: item.bcat_id,
      label: item.bcat_title,
      href: {
        pathname: filterPath,
        query: { category: item.bcat_id },
      },
    })) || []
  );
};

const getSubCategoryList = (bcatsData: any, category: string) => {
  return (
    (bcatsData &&
      (bcatsData.find((item: any) => item.bcat_id === category)?.sub_category ||
        bcatsData[0]?.sub_category)) ||
    []
  );
};

const getSubCategoryItems = (
  list: any,
  category: string,
  filterPath?: string,
) => {
  return list.map((item: any) => ({
    key: item.bcat_id,
    label: item.bcat_title,
    href: {
      pathname: filterPath,
      query: {
        category,
        subcategory: item.bcat_id,
      },
    },
  }));
};
